export default class StepTemplates
  @add_listeners: ->
    $(document).on 'input', '#js_step_template_weight', ->
      $input = $(this)
      val = $input.val()
      cursorPos = this.selectionStart
      originalCursorPos = cursorPos

      cleanVal = val.replace(/[^0-9.,]/g, '')

      if cleanVal.includes(',')
        cleanVal = cleanVal.replace(',', '.')

      dotCount = (cleanVal.match(/\./g) || []).length
      if dotCount > 1
        firstDotIndex = cleanVal.indexOf('.')
        cleanVal = cleanVal.substring(0, firstDotIndex + 1) + cleanVal.substring(firstDotIndex + 1).replace(/\./g, '')

      if cleanVal.includes('.')
        parts = cleanVal.split('.')
        if parts[1] && parts[1].length > 2
          cleanVal = parts[0] + '.' + parts[1].substring(0, 2)

      if cleanVal != '' && !isNaN(cleanVal)
        numVal = parseFloat(cleanVal)
        if numVal < 1 && cleanVal.length > 0 && cleanVal != '0'
          cleanVal = '1'

      if cleanVal != val
        $input.val(cleanVal)
        setTimeout ->
          $input[0].setSelectionRange(originalCursorPos, originalCursorPos)
        , 0
